import React from 'react';

import { useSelectorIsOneRosterActivatedSchool } from '../../../../../app';
import {
    useSelectorIsAdminUser, useSelectorIsTeacherUser
} from '../../../../../user-profiles';
import {
    UserProfileModalWrapper,
    UserProfile,
    ThreeEssentialsUserProfile
} from '../../components';

export const UserProfileModal = () => {
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const isAdmin = useSelectorIsAdminUser();
    const isTeacher = useSelectorIsTeacherUser();
    const showThreeEssentialsUserProfileModal = isOneRosterActivatedSchool && (isAdmin || isTeacher);

    if (showThreeEssentialsUserProfileModal) {
        return (
            <UserProfileModalWrapper backgroundColor={'#fff'} mb={'0 !important'}>
                <ThreeEssentialsUserProfile />
            </UserProfileModalWrapper>
        );
    }

    return (
        <UserProfileModalWrapper>
            <UserProfile />
        </UserProfileModalWrapper>
    );
};
